import { IHooksUseRequestEditVerificationStateParams } from '@/interfaces';
import { useMutation } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { useInvalidateQueries } from '@/hooks';
import { broadcastService } from '@/services';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

type TParams = {
  disableInvalidateQueries?: boolean;
};

type TDataVariables = IHooksUseRequestEditVerificationStateParams;

type TResponseData = string;

export const useRequestEditVerificationState = (params?: TParams) => {

  const { invalidate } = useInvalidateQueries();
  const { isPending, error, mutateAsync } = useMutation({
    mutationKey: [routes.api.verifications.base, 'editState'],
    mutationFn: ({ verificationId, ...data }: TDataVariables) =>
      apiClient
        .put<TResponseData>(`${routes.api.verifications.base}/${verificationId}`, data)
        .then(handleApiResponse)
        .then(
          () => (
            broadcastService
              .events
              .publish({
                type: 'verificationStateChanged',
                data: ({ verificationId, ...data })
              })
          )
        ),
    onSuccess: () => (
      !params?.disableInvalidateQueries &&
      Promise
        .all([
          invalidate(routes.api.verifications.completed),
          invalidate(routes.api.verifications.count),
          invalidate(routes.api.verifications.photo),
          invalidate(routes.api.certifications.base)
        ])
    )
  });

  const triggerEditVerificationState = (data: TDataVariables) =>
    mutateAsync(data);

  return ({
    isLoading: isPending,
    triggerEditVerificationState,
    error
  });

};  
